// extracted by mini-css-extract-plugin
module.exports = {"article":"Videos_article__2Fb0g","video":"Videos_video__1y_y6"};